export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  VERIFY_CODE: '/auth/verify-code',
  PAYMENT: '/payment',
  PAYMENT_IN_UPDATE: '/payment/in/update',
  PAYMENT_OUT_UPDATE: '/payment/out/update',
  DESIGN_SYSTEM: '/design-system',
  ONBOARDING_RENTERS_FORM: '/onboarding/renters/form',
  ONBOARDING_PET: '/onboarding/pet',
  ONBOARDING_RENTERS: '/onboarding/renters',
  ONBOARDING_PET_FORM: '/onboarding/pet/form',
  TELEVET: '/televet',
  CLAIMS: '/claims',
  CLAIM_DETAIL: '/claims/$claimId',
  CLAIM_EDIT: '/claims/$claimId/edit',
  CLAIMS_PET: '/claims/pet',
  CLAIMS_RENTERS: '/claims/renters',
  PET: '/pet',
  RENTERS: '/renters',
  PERKS: '/perks',
  GOALS: '/goals',
  DOCUMENTS: '/documents',
  CONTACT: '/contact',
  BILLING: '/billing',
} as const
